import { Injectable } from '@angular/core';
import { IApiBackendRouteService } from '../abstract/api-routes.service';
import { API_BASE_URL } from '../../../core/providers/constants/api.constants';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { LabelApiDto } from '../dto/label.dto';
import { PrinterDepartment } from '../types/printer-department';

@Injectable({
  providedIn: 'root',
})
export class ApiRouteLabelService extends IApiBackendRouteService {
  protected urlRoute = `${API_BASE_URL}/label`;

  constructor(protected readonly http: HttpClient) {
    super();
  }

  printLabel(body: LabelApiDto['printBasicWoLabel']['body']): Observable<any> {
    return this.http.post(`${this.urlRoute}/basic-wo`, body);
  }

  printZplLabel(
    data: LabelApiDto['printBasicZplLabel']['body']
  ): Observable<any> {
    return this.http.post(`${this.urlRoute}/basic-wo/zpl`, { ...data });
  }

  printersByDepartment(department: string): Observable<PrinterDepartment[]> {
    return this.http.get<PrinterDepartment[]>(
      `${this.urlRoute}/basic-wo/printers/${department}`
    );
  }

  sharedPrintersByDepartment(
    department: string
  ): Observable<PrinterDepartment[]> {
    return this.http.get<PrinterDepartment[]>(
      `${this.urlRoute}/basic-wo/shared-printers/${department}`
    );
  }

  /**
   * Pre-flight lookup the caller hits BEFORE asking the api/files service for
   * ZPL. Given a work order + sales order, the elite backend decides whether
   * a customer-specific private label applies:
   *
   *   - Customer match  → `{ labelType: '<customer>', data: <customer query> }`
   *                       The caller forwards this object straight into
   *                       `PackingBoxLabelCreatorApiService.createLabel(args)`
   *                       to obtain the ZPL string(s).
   *
   *   - No customer    → `{ labelType: null, data: null }`
   *                       The caller knows it must print the standard
   *                       packing-box label. It is responsible for building
   *                       the `StandardLabelBody` locally (work order /
   *                       packing-box context it already holds) and then
   *                       calling `createLabel({ data: <built body> })`.
   */
  informationForPrivateLabel(
    workOrderId: number,
    salesOrder: string
  ): Observable<LabelApiDto['privateLabelData']['result']> {
    return this.http.get<LabelApiDto['privateLabelData']['result']>(
      `${this.urlRoute}/builder/private-label-data`,
      { params: { workOrderId, salesOrder } }
    );
  }
}
